import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/mock";

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#16a34a] text-white shadow-xl shadow-[#16a34a]/30 transition hover:scale-105 hover:bg-[#15803d]"
    >
      <span className="absolute h-14 w-14 animate-ping rounded-full bg-[#16a34a]/40" />
      <MessageCircle className="relative h-6 w-6" strokeWidth={2.6} />
    </a>
  );
}
